//#region src/errors/application-error.ts
var ApplicationError = class extends Error {
	code;
	constructor(code, message) {
		super(message);
		this.code = code;
		this.name = this.constructor.name;
	}
};
//#endregion
//#region src/errors/api-request-error.ts
var ApiRequestError = class extends ApplicationError {
	status;
	constructor(status, code, message) {
		super(code, message);
		this.status = status;
	}
};
//#endregion
//#region src/errors/authentication-error.ts
var AuthenticationError = class extends ApplicationError {
	constructor(message = "Authentication failed") {
		super("AUTHENTICATION_ERROR", message);
	}
};
//#endregion
//#region src/errors/authorisation-error.ts
var AuthorizationError = class extends ApplicationError {
	constructor(message = "Access denied") {
		super("AUTHORIZATION_ERROR", message);
	}
};
//#endregion
//#region src/errors/conflict-error.ts
var ConflictError = class extends ApplicationError {
	constructor(message = "The request conflicts with existing state") {
		super("CONFLICT", message);
	}
};
//#endregion
//#region src/errors/not-found-error.ts
var NotFoundError = class extends ApplicationError {
	constructor(message) {
		super("NOT_FOUND", message);
	}
};
//#endregion
//#region src/errors/payload-too-large-error.ts
/**
* A request body exceeded the accepted size bound.
*
* Distinct from `ValidationError` because the remedy differs: a caller that
* reached the transport bound retries with a smaller request, whereas a caller
* that failed validation corrects a field. The bound itself belongs to whichever
* transport applies it, so the message is supplied rather than fixed here.
*/
var PayloadTooLargeError = class extends ApplicationError {
	constructor(message = "The request body exceeds the accepted size") {
		super("PAYLOAD_TOO_LARGE", message);
	}
};
//#endregion
//#region src/errors/too-many-requests-error.ts
/**
* A request was refused because a concurrency or rate bound was reached.
*
* It carries no retry-after interval, no limit, no remaining count and no
* window: a rate-limiting vocabulary in the platform error model on the strength
* of one caller is easy to add and hard to remove, and a caller whose bound is a
* concurrency bound has nothing to put in those fields — when it refuses it does
* not know when a slot will free. The bound belongs to whichever party applies
* it, so the message is supplied rather than fixed here.
*/
var TooManyRequestsError = class extends ApplicationError {
	constructor(message = "Too many requests") {
		super("TOO_MANY_REQUESTS", message);
	}
};
//#endregion
//#region src/errors/unsupported-media-type-error.ts
/**
* A request presented a media type the accepting party does not admit.
*
* Distinct from `ValidationError` because the remedy differs: a caller that
* presented an unaccepted type re-sends the request as an accepted one, whereas
* a caller that failed validation corrects a field. The accepted set belongs to
* whichever party applies it, so the message is supplied rather than fixed here.
*/
var UnsupportedMediaTypeError = class extends ApplicationError {
	constructor(message = "The request media type is not accepted") {
		super("UNSUPPORTED_MEDIA_TYPE", message);
	}
};
//#endregion
//#region src/errors/validation-error.ts
var ValidationError = class extends ApplicationError {
	constructor(message) {
		super("VALIDATION_ERROR", message);
	}
};
//#endregion
export { ApiRequestError, ApplicationError, AuthenticationError, AuthorizationError, ConflictError, NotFoundError, PayloadTooLargeError, TooManyRequestsError, UnsupportedMediaTypeError, ValidationError };

//# sourceMappingURL=index.mjs.map